module.exports = __webpack_public_path__ + "img/jm502.59a33160.png";